import BrandLoader from "./components/BrandLoader.jsx";
import { lazy, Suspense } from "react";
import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "./context/AuthContext.jsx";
import Layout       from "./components/Layout.jsx";
import Login        from "./pages/Login/index.jsx";
import { Loader2 }  from "./lib/icons.jsx";

/* Lazy load todas las páginas — reduce bundle inicial */
const Kanban           = lazy(() => import("./pages/Kanban/index.jsx"));
const Tareas           = lazy(() => import("./pages/Tareas/index.jsx"));
const Gantt            = lazy(() => import("./pages/Gantt/index.jsx"));
const TimeTracking     = lazy(() => import("./pages/TimeTracking/index.jsx"));
const Dashboard        = lazy(() => import("./pages/Dashboard/index.jsx"));
const Calendario       = lazy(() => import("./pages/Calendario/index.jsx"));
const Agenda           = lazy(() => import("./pages/Agenda/index.jsx"));
const GamifPodio       = lazy(() => import("./pages/Gamificacion/Podio.jsx"));
const FeedPreview      = lazy(() => import("./pages/FeedPreview/index.jsx"));
const StatusSemana     = lazy(() => import("./pages/StatusSemana/index.jsx"));
const MoodboardsTest   = lazy(() => import("./pages/MoodboardsTest/index.jsx"));
const Sorteos          = lazy(() => import("./pages/Sorteos/index.jsx"));
const SorteosAdmin     = lazy(() => import("./pages/Sorteos/admin.jsx"));
const SorteoDisplay    = lazy(() => import("./pages/Sorteos/display.jsx"));
// v7.6 Sprint G · Coberturas legacy borrado (usar CoberturasTablero abajo)
const Clientes         = lazy(() => import("./pages/Clientes/index.jsx"));
const ClienteDetalle   = lazy(() => import("./pages/Clientes/detalle.jsx"));
const Equipo           = lazy(() => import("./pages/Equipo/index.jsx"));
const Proyectos        = lazy(() => import("./pages/Proyectos/index.jsx"));
const MisClientes      = lazy(() => import("./pages/MisClientes/index.jsx"));
const Asignacion       = lazy(() => import("./pages/Asignacion/index.jsx"));
const Finanzas         = lazy(() => import("./pages/Finanzas/index.jsx"));
const Leads            = lazy(() => import("./pages/Leads/index.jsx"));
const Inicio           = lazy(() => import("./pages/Inicio/index.jsx"));
const InicioEjecutivo  = lazy(() => import("./pages/InicioEjecutivo/index.jsx"));
const CCCInbox         = lazy(() => import("./pages/Inbox/CCCInbox.jsx"));
const COMInbox         = lazy(() => import("./pages/Inbox/COMInbox.jsx"));
const ECInbox          = lazy(() => import("./pages/Inbox/ECInbox.jsx"));
const Facturacion      = lazy(() => import("./pages/Facturacion/index.jsx"));
const CCCCockpit       = lazy(() => import("./pages/CCC/Cockpit.jsx"));
const COMCockpit       = lazy(() => import("./pages/COM/Cockpit.jsx"));
const ECCockpit        = lazy(() => import("./pages/EC/Cockpit.jsx"));
const CPCCockpit       = lazy(() => import("./pages/CPC/Cockpit.jsx"));
const EquipoPerformance = lazy(() => import("./pages/Equipo/Performance.jsx"));
const EquipoDashboard   = lazy(() => import("./pages/Equipo/Dashboard.jsx"));
const MiPerfil          = lazy(() => import("./pages/MiPerfil/index.jsx"));
const Presentacion      = lazy(() => import("./pages/Presentacion/index.jsx"));
const PaginaYo          = lazy(() => import("./components/sistema/PantallaYo.jsx").then(m => ({ default: m.PaginaYo })));
const OKRs              = lazy(() => import("./pages/OKRs/index.jsx"));
const Equipos           = lazy(() => import("./pages/Equipos/index.jsx"));
const Partners          = lazy(() => import("./pages/Partners/index.jsx"));
const Influencers       = lazy(() => import("./pages/Influencers/index.jsx"));
const Academia          = lazy(() => import("./pages/Academia/index.jsx"));
const Tutoriales        = lazy(() => import("./pages/Ayuda/Tutoriales.jsx"));
const LeccionAyuda      = lazy(() => import("./pages/Ayuda/Leccion.jsx"));
const SeguimientoAyuda  = lazy(() => import("./pages/Ayuda/Seguimiento.jsx"));
const Autopiloto        = lazy(() => import("./pages/Autopiloto/index.jsx"));
const CalidadCliente    = lazy(() => import("./pages/CalidadCliente/index.jsx"));
const Tiempos            = lazy(() => import("./pages/Tiempos/index.jsx"));
const Publicacion       = lazy(() => import("./pages/Publicacion/index.jsx"));
const CentroAgentes     = lazy(() => import("./pages/Agentes/index.jsx"));
const Casos             = lazy(() => import("./pages/Casos/index.jsx"));
const AutopilotoPerfiles = lazy(() => import("./pages/AutopilotoPerfiles/index.jsx"));
const AutopilotoCorridas = lazy(() => import("./pages/AutopilotoCorridas/index.jsx"));
const AutopilotoMarca   = lazy(() => import("./pages/AutopilotoMarca/index.jsx"));
const ReportesSubs      = lazy(() => import("./pages/ReportesSubscripciones/index.jsx"));
const ProdTerceros      = lazy(() => import("./pages/ProduccionesTerceros/index.jsx"));
const LiveEvents        = lazy(() => import("./pages/LiveEvents/index.jsx"));
const MediaBuying       = lazy(() => import("./pages/MediaBuying/index.jsx"));
const Circles           = lazy(() => import("./pages/Circles/index.jsx"));
const PedidosCliente    = lazy(() => import("./pages/PedidosCliente/index.jsx"));
const Feedback          = lazy(() => import("./pages/Feedback/index.jsx"));
const Apelaciones       = lazy(() => import("./pages/Apelaciones/index.jsx"));
const CumplimientoOrg   = lazy(() => import("./pages/CumplimientoOrg/index.jsx"));
const PedidosAgencia    = lazy(() => import("./pages/PedidosAgencia/index.jsx"));
const CockpitCOOv2      = lazy(() => import("./pages/CockpitCOOv2/index.jsx"));
const CockpitCEOv2      = lazy(() => import("./pages/CockpitCEOv2/index.jsx"));
const CockpitCOOWrap    = lazy(() => import("./pages/CockpitCOOWrapper.jsx"));
const CockpitCEOWrap    = lazy(() => import("./pages/CockpitCEOWrapper.jsx"));
const FeeLedger         = lazy(() => import("./pages/FeeLedger/index.jsx"));
const CockpitUnificado  = lazy(() => import("./pages/CockpitUnificado.jsx"));
const BriefsPlan        = lazy(() => import("./pages/BriefsPlan/index.jsx"));
const GeneradorContenido = lazy(() => import("./pages/GeneradorContenido/index.jsx"));
const ClienteTimeline   = lazy(() => import("./pages/ClienteTimeline/index.jsx"));
const BuscarProducciones = lazy(() => import("./pages/BuscarProducciones/index.jsx"));
// Celebration provider (no lazy — small)
import { CelebrationProvider } from "./components/Celebration.jsx";
import { SwUpdateBanner } from "./components/SwUpdateBanner.jsx";
import { InstallBanner }  from "./components/InstallBanner.jsx";
import { useRealtimeSync } from "./hooks/useRealtimeSync.js";
const AdminFinanciero   = lazy(() => import("./pages/AdminFinanciero/index.jsx"));
// v8.4.42 · CockpitEjecutivo/CockpitCOO (v1) se importan directo desde sus
// Wrappers (CockpitCEOWrapper.jsx / CockpitCOOWrapper.jsx) — el import de acá
// era código muerto, ninguna <Route> lo usaba.
const RiskRadar         = lazy(() => import("./pages/RiskRadar/index.jsx"));
const AuditTrail        = lazy(() => import("./pages/AuditTrail/index.jsx"));
const AICost            = lazy(() => import("./pages/AICost/index.jsx"));
const CockpitMD          = lazy(() => import("./pages/CockpitMD/index.jsx"));   // v8.6.22 · Fase 8 Tier 1
const UsuariosEvento         = lazy(() => import("./pages/UsuariosEvento/index.jsx"));   // Usuarios por evento
const CoberturasControl      = lazy(() => import("./pages/CoberturasControl/index.jsx"));   // Coberturas fases 5 a 7
const Campo                 = lazy(() => import("./pages/Campo/index.jsx"));   // Coberturas fase 4 · modo campo
const Departamento          = lazy(() => import("./pages/Departamento/index.jsx"));   // Roles R4 · panel del jefe de departamento
const SaludCuentas         = lazy(() => import("./pages/SaludCuentas/index.jsx"));   // Roles R5 · salud de cuentas
const TableroTransicion    = lazy(() => import("./pages/TableroTransicion/index.jsx"));
const Cartera              = lazy(() => import("./pages/Cartera/index.jsx"));
const ReportesClientes     = lazy(() => import("./pages/ReportesClientes/index.jsx"));
const Pizarra              = lazy(() => import("./pages/Pizarra/index.jsx"));
const Conversaciones       = lazy(() => import("./pages/Conversaciones/index.jsx"));
const BandejaCuentas       = lazy(() => import("./pages/BandejaCuentas/index.jsx"));
const Chat                 = lazy(() => import("./pages/Chat/index.jsx"));
const Novedades            = lazy(() => import("./pages/Novedades/index.jsx"));
const Asignador           = lazy(() => import("./pages/Asignador/index.jsx"));   // Roles R1 · Asignador en sombra
const ITLead             = lazy(() => import("./pages/ITLead/index.jsx"));     // v8.6.22 · Fase 8 Tier 1
const ViaticosAprobacion = lazy(() => import("./pages/ViaticosAprobacion/index.jsx")); // v8.6.22 · Fase 8 Tier 3
const BancoRecursosResumen = lazy(() => import("./pages/BancoRecursosResumen/index.jsx")); // v8.6.23 · Fase 51
const ReportesArchivo   = lazy(() => import("./pages/ReportesArchivo/index.jsx"));
const RRHH              = lazy(() => import("./pages/RRHH/index.jsx"));
const CostosOperativos  = lazy(() => import("./pages/CostosOperativos/index.jsx"));
const Costeo            = lazy(() => import("./pages/Costeo/index.jsx"));
const AgencyOS          = lazy(() => import("./pages/AgencyOS/index.jsx"));
const MediaOps          = lazy(() => import("./pages/MediaOps/index.jsx"));
const AdminRoles        = lazy(() => import("./pages/AdminRoles/index.jsx"));
const AdminUsuarios     = lazy(() => import("./pages/AdminUsuarios/index.jsx"));
const ImportCliente     = lazy(() => import("./pages/Admin/ImportCliente.jsx"));
const AdminSettings     = lazy(() => import("./pages/AdminSettings/index.jsx"));
const AgentInbox        = lazy(() => import("./pages/AgentInbox/index.jsx"));
const SetupPendientes   = lazy(() => import("./pages/SetupPendientes/index.jsx"));
const NpsResponder      = lazy(() => import("./pages/NPS/index.jsx"));
const RecipesPage       = lazy(() => import("./pages/Recipes/index.jsx"));
const FeedbackPublic    = lazy(() => import("./pages/ClientFeedback/Public.jsx"));
const FeedbackDashboard = lazy(() => import("./pages/ClientFeedback/Dashboard.jsx"));
const InboxHub          = lazy(() => import("./pages/InboxHub/index.jsx"));
const Triage            = lazy(() => import("./pages/Triage/index.jsx"));
const OtrosCockpits     = lazy(() => import("./pages/OtrosCockpits/index.jsx"));
const SubtareasAnalytics = lazy(() => import("./pages/SubtareasAnalytics/index.jsx"));
const TareasCanceladas  = lazy(() => import("./pages/TareasCanceladas/index.jsx"));
const AdminBulk         = lazy(() => import("./pages/AdminBulk/index.jsx"));
const AdminAgencia      = lazy(() => import("./pages/AdminAgencia/index.jsx"));
const AdminChatStatus   = lazy(() => import("./pages/AdminChatStatus/index.jsx"));
const Scorecard         = lazy(() => import("./pages/Scorecard/index.jsx"));
const AdminCobranzas    = lazy(() => import("./pages/AdminCobranzas/index.jsx"));
const Procedimientos    = lazy(() => import("./pages/Procedimientos/index.jsx"));
const ProveedoresRanking= lazy(() => import("./pages/ProveedoresRanking/index.jsx"));
const CargaForecast     = lazy(() => import("./pages/CargaForecast/index.jsx"));
const EspecialistasDashboard = lazy(() => import("./pages/EspecialistasDashboard/index.jsx"));
const ActividadHoy      = lazy(() => import("./pages/ActividadHoy/index.jsx"));
const ScorecardRol      = lazy(() => import("./pages/ScorecardRol/index.jsx"));
const AdminDriveHealth  = lazy(() => import("./pages/AdminDriveHealth/index.jsx"));
const MiPipeline        = lazy(() => import("./pages/MiPipeline/index.jsx"));
const EquipoDetalle     = lazy(() => import("./pages/Equipo/detalle.jsx"));
const SettingsNotif     = lazy(() => import("./pages/SettingsNotificaciones/index.jsx"));
const CierreDia         = lazy(() => import("./pages/CierreDia/index.jsx"));
const CierreSemana      = lazy(() => import("./pages/CierreSemana/index.jsx"));
const MiTrabajo         = lazy(() => import("./pages/MiTrabajo/index.jsx"));
const TrabajoEquipo     = lazy(() => import("./pages/TrabajoEquipo/index.jsx"));
const MiCartera         = lazy(() => import("./pages/MiCartera/index.jsx"));
const MisCuentas        = lazy(() => import("./pages/MisCuentas/index.jsx"));
const Espacios          = lazy(() => import("./pages/Espacios/index.jsx"));
const Espacio           = lazy(() => import("./pages/Espacios/Espacio.jsx"));
const HojaUnoAUno       = lazy(() => import("./pages/HojaUnoAUno/index.jsx"));
const AnalyticsEquipo   = lazy(() => import("./pages/AnalyticsEquipo/index.jsx"));
const CoberturasTablero = lazy(() => import("./pages/Coberturas/Tablero.jsx"));
const CoberturasNueva   = lazy(() => import("./pages/Coberturas/Nueva.jsx"));
const PortalInbox       = lazy(() => import("./pages/PortalInbox/index.jsx"));  // v7.6.1 S3.3

/**
 * ProtectedRoute — redirige a /login si el usuario no está autenticado.
 * Muestra spinner mientras Firebase verifica la sesión persistida.
 */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  // Conexión SSE para sync en tiempo real (v5.2) — solo si hay user logueado
  useRealtimeSync();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-accent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}

import { Pagina404 } from "./components/sistema/PaginasSistema.jsx";

/* Smart index — redirige según rol */
function SmartIndex() {
  const { defaultPath } = useAuth();
  return <Navigate to={defaultPath ?? "/kanban"} replace />;
}

/* Inicio — Mi Día para roles operativos, Inicio Ejecutivo para liderazgo
 * (CEO/COO/CFO no tienen tareas operativas asignadas — ver sección 6.5 del
 * plan de mejora UX/UI, hallazgo confirmado en vivo por el CEO). */
function InicioRouter() {
  const { isAdmin, isCOO, isCFO } = useAuth();
  // SOA 10 PRO · ?vista=personal permite a dirección ver su Mi Día personal (el de tareas propias).
  const [sp] = useSearchParams();
  const personal = sp.get("vista") === "personal";
  return (isAdmin || isCOO || isCFO) && !personal ? <InicioEjecutivo /> : <Inicio />;
}

/* Fallback de Suspense — spinner centrado mientras carga el chunk */
function PageLoading() {
  return <BrandLoader texto="Cargando…" />;
}

/* Wrap para que cada route tenga su propio Suspense boundary */
function L({ children }) {
  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
}

export default function App() {
  return (
    <CelebrationProvider>
    <SwUpdateBanner />
    <InstallBanner />
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      <Route path="/nps/:token" element={<L><NpsResponder /></L>} />
      <Route path="/feedback/:clienteId" element={<L><FeedbackPublic /></L>} />
      {/* v7.2 · Display público del sorteo (sin auth, full screen) */}
      <Route path="/sorteos/display/:slug" element={<L><SorteoDisplay /></L>} />

      {/* Protected — todas las rutas de la app */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index                element={<SmartIndex />} />
        <Route path="inicio"        element={<L><InicioRouter /></L>} />
        <Route path="kanban"        element={<L><Kanban /></L>} />
        <Route path="tareas"        element={<L><Tareas /></L>} />
        <Route path="gantt"         element={<L><Gantt /></L>} />
        <Route path="dashboard"     element={<L><Dashboard /></L>} />
        <Route path="finanzas"      element={<L><Finanzas /></L>} />
        {/* Cockpit unificado con selector rol (COO/CEO/Otros) · rutas viejas siguen vivas */}
        <Route path="cockpit"       element={<L><CockpitUnificado /></L>} />
        <Route path="asignacion"    element={<L><Asignacion /></L>} />
        <Route path="mis-clientes"  element={<L><MisClientes /></L>} />
        <Route path="leads"         element={<L><Leads /></L>} />
        <Route path="ccc/inbox"     element={<L><CCCInbox /></L>} />
        <Route path="com/inbox"     element={<L><COMInbox /></L>} />
        <Route path="ec/inbox"      element={<L><ECInbox /></L>} />
        <Route path="inbox-hub"     element={<L><InboxHub /></L>} />
        <Route path="triage"        element={<L><Triage /></L>} />
        <Route path="otros-cockpits" element={<L><OtrosCockpits /></L>} />
        <Route path="analytics/subtareas" element={<L><SubtareasAnalytics /></L>} />
        <Route path="analytics/canceladas" element={<L><TareasCanceladas /></L>} />
        <Route path="admin/bulk"          element={<L><AdminBulk /></L>} />
        <Route path="admin/agencia"       element={<L><AdminAgencia /></L>} />
        <Route path="admin/chat-status"   element={<L><AdminChatStatus /></L>} />
        <Route path="equipo/:id/scorecard" element={<L><Scorecard /></L>} />
        <Route path="admin/cobranzas"     element={<L><AdminCobranzas /></L>} />
        <Route path="procedimientos"      element={<L><Procedimientos /></L>} />
        <Route path="proveedores"         element={<L><ProveedoresRanking /></L>} />
        <Route path="carga-forecast"      element={<L><CargaForecast /></L>} />
        <Route path="especialistas-dashboard" element={<L><EspecialistasDashboard /></L>} />
        <Route path="actividad-hoy"       element={<L><ActividadHoy /></L>} />
        <Route path="actividad-hoy/:id"   element={<L><ActividadHoy /></L>} />
        <Route path="scorecard-rol"       element={<L><ScorecardRol /></L>} />
        <Route path="scorecard-rol/:userId" element={<L><ScorecardRol /></L>} />
        <Route path="admin/drive-health"  element={<L><AdminDriveHealth /></L>} />
        <Route path="mi-pipeline"         element={<L><MiPipeline /></L>} />
        <Route path="equipo/cierre-dia"   element={<L><CierreDia /></L>} />
        <Route path="equipo/cierre-semana" element={<L><CierreSemana /></L>} />
        <Route path="mi-trabajo"          element={<L><MiTrabajo /></L>} />
        <Route path="mi-trabajo/:userId"  element={<L><MiTrabajo /></L>} />
        <Route path="trabajo-equipo"      element={<L><TrabajoEquipo /></L>} />
        <Route path="mi-cartera"          element={<L><MiCartera /></L>} />
        <Route path="mi-cartera/:ecId"    element={<L><MiCartera /></L>} />
        <Route path="espacios"            element={<L><Espacios /></L>} />
        <Route path="espacios/:id"        element={<L><Espacio /></L>} />
        <Route path="mis-cuentas"         element={<L><MisCuentas /></L>} />
        <Route path="mis-cuentas/:comId"  element={<L><MisCuentas /></L>} />
        <Route path="hoja-1a1"            element={<L><HojaUnoAUno /></L>} />
        <Route path="hoja-1a1/:userId"    element={<L><HojaUnoAUno /></L>} />
        <Route path="analytics/equipo"    element={<L><AnalyticsEquipo /></L>} />
        <Route path="coberturas-v2"       element={<L><CoberturasTablero /></L>} />
        <Route path="coberturas-v2/nueva" element={<L><CoberturasNueva /></L>} />
        {/* v7.6.1 S3.3 · Inbox EC/CCC · chats con clientes desde portal */}
        <Route path="portal-inbox"        element={<L><PortalInbox /></L>} />
        <Route path="portal-inbox/:clienteId" element={<L><PortalInbox /></L>} />
        <Route path="settings/notificaciones" element={<L><SettingsNotif /></L>} />
        <Route path="facturacion"   element={<L><Facturacion /></L>} />
        <Route path="ccc/cockpit"   element={<L><CCCCockpit /></L>} />
        <Route path="com/cockpit"   element={<L><COMCockpit /></L>} />
        <Route path="ec/cockpit"    element={<L><ECCockpit /></L>} />
        <Route path="cpc/cockpit"   element={<L><CPCCockpit /></L>} />
        <Route path="equipo/dashboard" element={<L><EquipoDashboard /></L>} />
        <Route path="mi-perfil"        element={<L><MiPerfil /></L>} />
        <Route path="presentacion"     element={<L><Presentacion /></L>} />
        <Route path="yo"               element={<L><PaginaYo /></L>} />
        <Route path="okrs"             element={<L><OKRs /></L>} />
        <Route path="equipos"          element={<L><Equipos /></L>} />
        <Route path="partners"         element={<L><Partners /></L>} />
        <Route path="influencers"      element={<L><Influencers /></L>} />
        <Route path="academia"         element={<L><Academia /></L>} />
        <Route path="ayuda/tutoriales"     element={<L><Tutoriales /></L>} />
        <Route path="ayuda/tutoriales/:id" element={<L><LeccionAyuda /></L>} />
        <Route path="ayuda/seguimiento"    element={<L><SeguimientoAyuda /></L>} />
        <Route path="autopiloto"           element={<L><Autopiloto /></L>} />
        <Route path="calidad/cliente"      element={<L><CalidadCliente /></L>} />
        <Route path="tiempos"              element={<L><Tiempos /></L>} />
        <Route path="publicacion"          element={<L><Publicacion /></L>} />
        <Route path="agentes"              element={<L><CentroAgentes /></L>} />
        <Route path="casos"                element={<L><Casos /></L>} />
        <Route path="autopiloto/perfiles"  element={<L><AutopilotoPerfiles /></L>} />
        <Route path="autopiloto/corridas"  element={<L><AutopilotoCorridas /></L>} />
        <Route path="autopiloto/marca/:clienteId" element={<L><AutopilotoMarca /></L>} />
        <Route path="reportes/suscripciones" element={<L><ReportesSubs /></L>} />
        <Route path="producciones-terceros"  element={<L><ProdTerceros /></L>} />
        <Route path="buscar-producciones"    element={<L><BuscarProducciones /></L>} />
        <Route path="live-events"            element={<L><LiveEvents /></L>} />
        <Route path="media-buying"           element={<L><MediaBuying /></L>} />
        <Route path="circles"                element={<L><Circles /></L>} />
        <Route path="pedidos-cliente"        element={<L><PedidosCliente /></L>} />
        <Route path="feedback"               element={<L><Feedback /></L>} />
        <Route path="mi-dia"                 element={<Navigate to="/inicio" replace />} />
        <Route path="apelaciones"            element={<L><Apelaciones /></L>} />
        <Route path="admin/cumplimiento-org" element={<L><CumplimientoOrg /></L>} />
        <Route path="pedidos-agencia"        element={<L><PedidosAgencia /></L>} />
        <Route path="cockpit/coo-v2"         element={<L><CockpitCOOv2 /></L>} />
        <Route path="cockpit/ceo-v2"         element={<L><CockpitCEOv2 /></L>} />
        <Route path="cockpit/coo"            element={<L><CockpitCOOWrap /></L>} />
        <Route path="cockpit/ceo"            element={<L><CockpitCEOWrap /></L>} />
        <Route path="briefs-plan"            element={<L><BriefsPlan /></L>} />
        <Route path="generador-contenido"    element={<L><GeneradorContenido /></L>} />
        <Route path="clientes/:id/timeline"  element={<L><ClienteTimeline /></L>} />
        <Route path="equipo/:id"             element={<L><EquipoDetalle /></L>} />
        <Route path="equipo/:id/performance" element={<L><EquipoPerformance /></L>} />
        <Route path="admin/financiero" element={<L><AdminFinanciero /></L>} />
        <Route path="fee-ledger"    element={<L><FeeLedger /></L>} />
        <Route path="risk-radar"    element={<L><RiskRadar /></L>} />
        <Route path="audit"         element={<L><AuditTrail /></L>} />
        <Route path="ai-cost"       element={<L><AICost /></L>} />
        <Route path="cockpit/md"    element={<L><CockpitMD /></L>} />
        <Route path="it-lead"       element={<L><ITLead /></L>} />
        <Route path="transicion"    element={<L><TableroTransicion /></L>} />
        <Route path="cartera"       element={<L><Cartera /></L>} />
        <Route path="reportes-clientes" element={<L><ReportesClientes /></L>} />
        <Route path="pizarra"      element={<L><Pizarra /></L>} />
        <Route path="chat" element={<L><Chat /></L>} />
        <Route path="novedades" element={<L><Novedades /></L>} />
        <Route path="conversaciones" element={<L><Conversaciones /></L>} />
        <Route path="bandeja-cuentas" element={<L><BandejaCuentas /></L>} />
        <Route path="asignador"     element={<L><Asignador /></L>} />
        <Route path="cuentas/salud" element={<L><SaludCuentas /></L>} />
        <Route path="departamento/:id" element={<L><Departamento /></L>} />
        <Route path="campo" element={<L><Campo /></L>} />
        <Route path="usuarios-evento" element={<L><UsuariosEvento /></L>} />
        <Route path="coberturas/control" element={<L><CoberturasControl /></L>} />
        <Route path="viaticos"      element={<L><ViaticosAprobacion /></L>} />
        <Route path="banco-recursos" element={<L><BancoRecursosResumen /></L>} />
        <Route path="reportes"      element={<L><ReportesArchivo /></L>} />
        <Route path="rrhh"          element={<L><RRHH /></L>} />
        <Route path="costos-operativos" element={<L><CostosOperativos /></L>} />
        <Route path="costeo"        element={<L><Costeo /></L>} />
        {/* Cockpits v1 deprecados → redirigen a v2 wrappers */}
        <Route path="cockpit-ejecutivo" element={<Navigate to="/cockpit/ceo" replace />} />
        <Route path="cockpit-coo"       element={<Navigate to="/cockpit/coo" replace />} />
        <Route path="agency-os"         element={<L><AgencyOS /></L>} />
        <Route path="media-ops"         element={<L><MediaOps /></L>} />
        <Route path="admin/roles"       element={<L><AdminRoles /></L>} />
        <Route path="admin/usuarios"        element={<L><AdminUsuarios /></L>} />
        <Route path="admin/import-cliente"  element={<L><ImportCliente /></L>} />
        <Route path="admin/settings"    element={<L><AdminSettings /></L>} />
        <Route path="agent-inbox"       element={<L><AgentInbox /></L>} />
        <Route path="setup-pendientes"  element={<L><SetupPendientes /></L>} />
        <Route path="recetas"            element={<L><RecipesPage /></L>} />
        <Route path="client-feedback"    element={<L><FeedbackDashboard /></L>} />
        <Route path="horas"         element={<L><TimeTracking /></L>} />
        <Route path="calendario"    element={<L><Calendario /></L>} />
        <Route path="agenda"        element={<L><Agenda /></L>} />
        <Route path="gamificacion/podio" element={<L><GamifPodio /></L>} />
        <Route path="feed-preview"           element={<L><FeedPreview /></L>} />
        <Route path="feed-preview/:clienteId" element={<L><FeedPreview /></L>} />
        <Route path="status-semana"             element={<L><StatusSemana /></L>} />
        <Route path="status-semana/:clienteId"  element={<L><StatusSemana /></L>} />
        <Route path="campana/:grupoId/deck"     element={<Navigate to="/tareas" replace />} />
        <Route path="moodboards-test"           element={<L><MoodboardsTest /></L>} />
        {/* v7.2 · Sorteos */}
        <Route path="sorteos"                   element={<L><Sorteos /></L>} />
        <Route path="sorteos/:id"               element={<L><SorteosAdmin /></L>} />
        {/* v7.6 · /coberturas redirige a /coberturas-v2 (unificación) */}
        <Route path="coberturas"          element={<Navigate to="/coberturas-v2" replace />} />
        <Route path="coberturas/:id"      element={<Navigate to="/coberturas-v2" replace />} />
        <Route path="producciones-legacy" element={<Navigate to="/coberturas-v2" replace />} />
        <Route path="clientes"      element={<L><Clientes /></L>} />
        <Route path="clientes/:id"  element={<L><ClienteDetalle /></L>} />
        <Route path="equipo"        element={<L><Equipo /></L>} />
        <Route path="proyectos"     element={<L><Proyectos /></L>} />
        <Route path="*"             element={<Pagina404 />} />
      </Route>
    </Routes>
    </CelebrationProvider>
  );
}
